// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SpcSelector from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import PromotionBanner from '../views/PromotionBanner.view';
import {
  getTcpSegmentValue,
  getIsBossEnabled,
  getNewChangeStoreUICNC,
} from '../../../../../reduxStore/selectors/session.selectors';
import { getBrand, isCanada } from '../../../../../utils';

export const PromotionBannerContainer = ({
  tcpSegmentValue,
  bossBanner,
  fullBleed,
  itemBrand = getBrand(),
  isPickupMobilePromotion,
  isCountryCanada,
  isBossEnabled,
  isATBModalBackAbTestNewDesign,
  isfromNewdesign,
  isAddedToBagRedesign,
  isFromNoRushTileShowLoader,
  isBossMultipleStoreEnabled,
  fromBossSwitch,
  isNewChangeStoreUIEnabledCNC,
  fromBagPage,
  isSPC,
  isShoppingBag,
}) =>
  !isCountryCanada && (isBossEnabled || fromBossSwitch) ? (
    <PromotionBanner
      isfromNewdesign={isfromNewdesign}
      tcpSegmentValue={tcpSegmentValue}
      bossBanner={bossBanner}
      fullBleed={fullBleed}
      itemBrand={itemBrand}
      isPickupMobilePromotion={isPickupMobilePromotion}
      isATBModalBackAbTestNewDesign={isATBModalBackAbTestNewDesign}
      isAddedToBagRedesign={isAddedToBagRedesign}
      isFromNoRushTileShowLoader={isFromNoRushTileShowLoader}
      isBossMultipleStoreEnabled={isBossMultipleStoreEnabled}
      isNewChangeStoreUIEnabledCNC={isNewChangeStoreUIEnabledCNC}
      fromBagPage={fromBagPage}
      isSPC={isSPC}
      isShoppingBag={isShoppingBag}
      fromBossSwitch={fromBossSwitch}
    />
  ) : null;

export const mapStateToProps = (state) => {
  return {
    tcpSegmentValue: getTcpSegmentValue(state),
    isCountryCanada: isCanada(),
    isBossEnabled: getIsBossEnabled(state),
    isNewChangeStoreUIEnabledCNC: getNewChangeStoreUICNC(state),
    isSPC: SpcSelector.checkIsSinglePageCheckout(state),
  };
};

PromotionBannerContainer.propTypes = {
  bossBanner: PropTypes.bool,
  fullBleed: PropTypes.bool,
  tcpSegmentValue: PropTypes.string.isRequired,
  itemBrand: PropTypes.string.isRequired,
  isPickupMobilePromotion: PropTypes.bool,
  isCountryCanada: PropTypes.bool,
  isBossEnabled: PropTypes.bool,
  isATBModalBackAbTestNewDesign: PropTypes.bool,
  isFromNoRushTileShowLoader: PropTypes.bool,
};

PromotionBannerContainer.defaultProps = {
  bossBanner: false,
  fullBleed: false,
  isPickupMobilePromotion: false,
  isCountryCanada: false,
  isBossEnabled: true,
  isATBModalBackAbTestNewDesign: false,
  isFromNoRushTileShowLoader: true,
};
export default connect(mapStateToProps)(PromotionBannerContainer);
